<template>
  <footer>
    <div class="cont">
      <div class="company">
        <div class="logo"><img src="./../assets/comm/logo_hppc.png" alt="和平電力" /></div>
        <div class="contact">
          <div class="item">
            <i class="fa-solid fa-phone"></i> <span class="tit">電話：03-868-1900</span>
          </div>
          <div class="item">
            <i class="fa-solid fa-print"></i> <span class="tit">傳真：03-868-2050</span>
          </div>
          <div class="item">
            <i class="fa-solid fa-location-dot"></i> <span class="tit">地址：花蓮縣秀林鄉和平村和工二路七號</span>
          </div>
          <div class="item">
            <i class="fa-solid fa-envelope"></i> <span class="tit">Email：<a href="mailto:hppcservice@hppc.com.tw">hppcservice@hppc.com.tw</a></span>
          </div>
        </div>
      </div>
      <div class="social">
        <a class="item" target="_blank" href="https://www.facebook.com/TaiwanCementCorporation/">
          <div class="logo"><img src="./../assets/footer/socialFB.png" /></div>
          <div class="tit">台泥企業團</div>
        </a>
        <a class="item" target="_blank" href="https://www.facebook.com/HanbenOceanStation/?ref=pages_you_manage">
          <div class="logo"><img src="./../assets/footer/socialFB.png" /></div>
          <div class="tit">漢本海洋驛站</div>
        </a>
        <a class="item" target="_blank" href="https://www.facebook.com/tccdaka/?eid=ARDZl64lWEjaNuhP3GvqIs57A2aOSBWB1WvQeiD61_zAJM_wLxzXtiB1LY9bcRUW4U3wzrX59GR4T2-n/">
          <div class="logo"><img src="./../assets/footer/socialFB.png" /></div>
          <div class="tit">台泥DAKA 和平微旅</div>
        </a>
      </div>      
    </div>
    <div class="copyright">©{{year}} 和平電力股份有限公司 Ho-Ping Power Company</div>
  </footer>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { UrlPath, Util } from '../util/util';

export default defineComponent({
  name: 'CommFooter',
  props: {
    // msg: String,
    from: String
  },
  data: function() {
    return {
        urlPath: UrlPath,
        year: new Date().getFullYear()
    }
  },
  methods: {
    setUrl: function(pathName: string) {
      return Util.setUrl(pathName);
    }
  },
  mounted() {    
    if(this.from == "index") {
      (document.querySelector("footer") as HTMLElement).style.position = "fixed";
      (document.querySelector("footer") as HTMLElement).style.bottom = "0";

      setTimeout( () => {
        (document.querySelector("footer") as HTMLElement).style.position = "static";  
      }, 1000);
      // (document.querySelector("footer .cont") as HTMLElement).style.display = "none";
    } else if(this.from === undefined) {
      // (document.querySelector("footer") as HTMLElement).classList.add("gray");
    }

    (document.querySelector("footer .cont") as HTMLElement).style.display = "none";
  }
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
footer {
  width: 100%;
  border-top: solid 1px #e8e8e8;
  box-sizing: border-box;
  /* background: #fff; */
  background: #0C5F99;
}

footer.gray {
  background: #f0f0f0;
}

footer .cont {
  width: 1200px;
  margin: auto;
  padding: 60px 0 20px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

footer .cont .company {
  flex: 0 0 50%;
  display: flex;
  /* background: #ccc; */
}

footer .cont .company .logo {
  flex: 0 0 120px;
}

footer .cont .company .logo img {
  width: 100%;
  vertical-align: bottom;
}

footer .cont .company .contact {
  flex: 0 0 auto;
  padding: 0 0 0 30px;
  box-sizing: border-box;
  border-bottom: solid 1px #c0c0c0;
  text-align: left;
}

footer .cont .company .contact .item {
  padding: 0 0 10px;
  box-sizing: border-box;
}

footer .cont .company .contact .item:last-child {
  padding: 0;
}

footer .cont .social {
  flex: 0 0 200px;
}

footer .cont .social .item {
  display: flex;
  padding: 0 0 10px;
  box-sizing: border-box;
  align-items: center;
}

footer .cont .social .item .logo {
  flex: 0 0 30px;
  height: 30px;
  border-top-left-radius: 7px;
  border-bottom-left-radius: 7px;
  overflow: hidden;
}

footer .cont .social .item .logo img {
  width: 100%;
}

footer .cont .social .item .tit {
  flex: 1 0 auto;
  height: 30px;
  padding: 0 10px;
  display: flex;
  align-items: center;
  border-left: solid 2px #f0f0f0;
  border-top-right-radius: 7px;
  border-bottom-right-radius: 7px;
  color: #000;
  background: #d8d8d8;
}

footer .copyright {
  width: 1200px;
  margin: auto;
  padding: 11px 0;
  box-sizing: border-box;
  text-align: right;
  font-size: 12px;
  color: #fff;
  /* background: #0088cc; */
  /* background: #e6f6ff; */
}

@media screen and (min-width: 1px) and (max-width: 1200px) {
  footer .cont {
    width: 100%;
  }

  footer .cont .company .contact {
    flex: 0 0 100%;
  }

  footer .copyright {
    width: 100%;
    text-align: center;
  }
}
</style>